import { Route } from '@angular/router';
import { AsideComponent } from './components/aside/aside.component';
import { authGuard, KycGuard, TokenGuard } from '@ose/services';
import { NotFoundComponent } from '@ose/components';

const TITLE_PREFIX = '';

export const appRoutes: Route[] = [
  { path: 'not-found', component: NotFoundComponent },
  {
    path: '',
    redirectTo: 'dashboard',
    pathMatch: 'full',
  },
  {
    path: 'auth',
    canActivate: [TokenGuard],
    loadComponent: () =>
      import('@ose/layouts').then((m) => m.AuthLayoutComponent),
    data: { subsSystem: 'client' },
    title: TITLE_PREFIX + 'Authentication',
    children: [
      {
        path: 'sign-in',
        loadComponent: () => import('@ose/auth').then((m) => m.SignInComponent),
        title: TITLE_PREFIX + 'Sign In',
      },
      {
        path: 'sign-up',
        loadComponent: () => import('@ose/auth').then((m) => m.SignUpComponent),
        title: TITLE_PREFIX + 'Sign Up',
      },
      {
        path: 'reset-password',
        loadComponent: () =>
          import('@ose/auth').then((m) => m.ResetPasswordComponent),
        title: TITLE_PREFIX + 'Reset Password',
      },
    ],
  },
  {
    path: 'remittances/init/:id',
    loadComponent: () =>
      import('@ose/finance').then((m) => m.InitRemittanceComponent),
    title: TITLE_PREFIX + 'Pay Remittance',
  },
  {
    path: '',
    canActivate: [authGuard],
    loadComponent: () =>
      import('@ose/layouts').then((m) => m.DashboardLayoutComponent),
    data: { subsSystem: 'client', sidebar: AsideComponent },
    title: TITLE_PREFIX + 'Dashboard',
    children: [
      {
        path: 'dashboard',
        loadComponent: () =>
          import(
            './features/dashboard/pages/dashboard/dashboard.component'
          ).then((m) => m.DashboardComponent),
        title: TITLE_PREFIX + 'Dashboard',
      },
      {
        path: 'kyc-required',
        loadComponent: () =>
          import('@ose/member').then((m) => m.KycRequiredPage),
        title: TITLE_PREFIX + 'Authentication',
      },
      {
        path: 'wallets',
        loadComponent: () => import('@ose/finance').then((m) => m.WalletsPage),
        title: TITLE_PREFIX + 'Wallets',
      },
      {
        path: 'transactions',
        loadComponent: () =>
          import('@ose/finance').then((m) => m.TransactionsPage),
        title: TITLE_PREFIX + 'Transactions',
      },
      {
        path: 'remittances',

        loadComponent: () =>
          import('@ose/finance').then((m) => m.RemittancesPage),
        title: TITLE_PREFIX + 'Remittances',
      },
      {
        path: 'remittances/payment/:id',
        canActivate: [KycGuard],
        loadComponent: () =>
          import('@ose/finance').then((m) => m.ConfirmRemittanceComponent),
        title: TITLE_PREFIX + 'Pay Remittance',
      },
      {
        path: 'remittances/result/:id',
        loadComponent: () =>
          import('@ose/finance').then((m) => m.ResultRemittanceComponent),
        title: TITLE_PREFIX + 'Remittances',
      },
      {
        path: 'bank-accounts',

        loadComponent: () =>
          import('@ose/finance').then((m) => m.BankAccountsPage),
        title: TITLE_PREFIX + 'BankAccounts',
      },
      {
        path: 'identification',
        loadComponent: () =>
          import('@ose/member').then((m) => m.AuthenticationPage),
        title: TITLE_PREFIX + 'Authentication',
      },
      {
        path: 'deposit',
        canActivate: [KycGuard],
        loadComponent: () => import('@ose/finance').then((m) => m.DepositPage),
        title: 'Deposit',
        data: { titleParams: { obj: 'Payment' } },
      },
      {
        path: 'withdraw',
        canActivate: [KycGuard],
        loadComponent: () => import('@ose/finance').then((m) => m.WithdrawPage),
        title: 'Withdraw',
        data: { titleParams: { obj: 'Payment' } },
      },
      {
        path: 'deposit/:id',
        canActivate: [KycGuard],
        loadComponent: () => import('@ose/finance').then((m) => m.DepositPage),
        title: 'Deposit',
        data: { titleParams: { obj: 'Payment' } },
      },
      {
        path: 'exchange/:type',
        canActivate: [KycGuard],
        loadComponent: () =>
          import('@ose/finance').then((m) => m.CurrencyExchangePage),
        title: 'Exchange',
        data: { titleParams: { obj: 'Currency' } },
      },
      {
        path: 'change-password',
        loadComponent: () =>
          import('@ose/auth').then((m) => m.ResetPasswordComponent),
        title: TITLE_PREFIX + 'ChangePassword',
      },
      { path: '**', redirectTo: '/not-found' },
    ],
  },
];
